import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/axiosInstance";

const initialState = {
  trade: {},
  success: false,
  error: false,
  loading: false,
  info: {},
  tickerNameSearch: {},
};

export const reset = createAsyncThunk(
  "trade/reset",
  () => ({})
);

export const create = createAsyncThunk(
  "trade/create",
  async (formInfo, { dispatch, rejectWithValue }) => {
    try {
      const {accountValueAddEnable, trade_type, security_type, trade_direction, ticker_name, trade_date, expiry, strike, buy_value, units, rr, pnl, percent_wl, fees, comments } = formInfo;
      const res = await api.post(`trade/create/${accountValueAddEnable}`, {
        trade_type,
        security_type,
        trade_direction,
        ticker_name,
        trade_date,
        expiry,
        strike,
        buy_value,
        units,
        rr,
        pnl,
        percent_wl,
        fees,
        comments
      });
      console.log(res);
      return res.data
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTrade = createAsyncThunk(
  "trade/getTrade",
  async (formInfo, { dispatch, rejectWithValue }) => {
    try {
      const { trade_id } = formInfo;
      const res = await api.get(`trade/${trade_id}`);
      console.log(res);
      return res.data
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const searchTicker = createAsyncThunk(
  "trade/searchTicker",
  async (formInfo, { dispatch, rejectWithValue }) => {
    try {
      const { filter } = formInfo;
      const res = await api.get(`trade/searchTicker`, { params: filter });
      console.log(res);
      return res.data
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const deleteTrade = createAsyncThunk(
  "trade/deleteTrade",
  async (formInfo, { dispatch, rejectWithValue }) => {
    try {
      const { accountValueDeleteEnable, trade_ids } = formInfo;
      const res = await api.delete(`trade/deleteTrades/${accountValueDeleteEnable}`, { data: trade_ids });
      console.log(res);
      return res.data
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const updateTrades = createAsyncThunk(
  "trade/updateTrades",
  async (formInfo, { dispatch, rejectWithValue }) => {
    try {
      const { accountValueUpdateTradesEnable, ids, update_info } = formInfo;
      const res = await api.post(`trade/updateTrades/${accountValueUpdateTradesEnable}`, {
        ids,
        update_info
      });
      console.log(res);
      return res.data
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const importCsv = createAsyncThunk(
  "trade/importCsv",
  async (formInfo, { dispatch, rejectWithValue }) => {
    try {
      const { accountValueImportEnable, selectedFile } = formInfo;

      if (!selectedFile) {
        return rejectWithValue({ message: "No file provided" });
      }

      const formData = new FormData();
      formData.append("csv_file", selectedFile);

      const res = await api.post(`trade/importCsv/${accountValueImportEnable}`, formData);
      console.log(res);
      return res.data
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const bulkUpdateCsv = createAsyncThunk(
  "trade/bulkUpdateCsv",
  async (formInfo, { dispatch, rejectWithValue }) => {
    try {
      const { accountValueUpdateCSVEnable, selectedFile } = formInfo;
      const formData = new FormData();
      formData.append("csv_file", selectedFile);
      const res = await api.post(`trade/bulkUpdateCsv/${accountValueUpdateCSVEnable}`, formData);
      console.log(res);
      return res.data
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const exportCsv = createAsyncThunk(
  "trade/exportCsv",
  async (formInfo, { dispatch, rejectWithValue }) => {
    try {
      const { exported_trades } = formInfo;
      const res = await api.post(`trade/exportCsv`, {
        exported_trades: exported_trades
      }, {
        headers: { "Content-Type": "application/json" }
      });
      console.log(res);
      return res.data
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const update = createAsyncThunk(
  "trade/update",
  async (formInfo, { dispatch, rejectWithValue }) => {
    try {
      const { accountValueUpdateEnable, trade_id, trade_type, security_type, trade_direction, ticker_name, trade_date, expiry, strike, buy_value, units, rr, pnl, percent_wl, fees, comments } = formInfo;
      const res = await api.post(`trade/${trade_id}/${accountValueUpdateEnable}`, {
        trade_type,
        security_type,
        trade_direction,
        ticker_name,
        trade_date,
        expiry,
        strike,
        buy_value,
        units,
        rr,
        pnl,
        percent_wl,
        fees,
        comments
      });
      console.log(res);
      return res.data
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

const tradeSlice = createSlice({
    name: "trade",
    initialState,
    reducers: {},
    extraReducers: {
      [getTrade.fulfilled]: (state, action) => {
        state.trade = action.payload;
        state.success = true;
        state.error = false;
        state.loading = false;
      },
      [getTrade.pending]: (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      },
      [getTrade.rejected]: (state, action) => {
        state.error = true;
        state.info = action.payload;
        state.loading = false;
      },
      [searchTicker.fulfilled]: (state, action) => {
        state.tickerNameSearch = action.payload;
        state.success = true;
        state.error = false;
        state.loading = false;
      },
      [searchTicker.pending]: (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      },
      [searchTicker.rejected]: (state, action) => {
        state.error = true;
        state.info = action.payload;
        state.loading = false;
      },
      [deleteTrade.fulfilled]: (state, action) => {
        state.trade = action.payload;
        state.success = true;
        state.error = false;
        state.loading = false;
      },
      [deleteTrade.pending]: (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      },
      [deleteTrade.rejected]: (state, action) => {
        state.error = true;
        state.info = action.payload;
        state.loading = false;
      },
      [updateTrades.fulfilled]: (state, action) => {
        state.trade = action.payload;
        state.success = true;
        state.error = false;
        state.loading = false;
      },
      [updateTrades.pending]: (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      },
      [updateTrades.rejected]: (state, action) => {
        state.error = true;
        state.info = action.payload;
        state.loading = false;
      },
      [create.fulfilled]: (state, action) => {
        state.loading = false;
        state.success = true;
        state.trade = action.payload;
        state.error = false;
      },
      [create.pending]: (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      },
      [create.rejected]: (state, action) => {
        state.error = true;
        state.info = action.payload;
        state.loading = false;
      },
      [update.fulfilled]: (state, action) => {
        state.loading = false;
        state.success = true;
        state.trade = action.payload;
        state.error = false;
      },
      [update.pending]: (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      },
      [update.rejected]: (state, action) => {
        state.error = true;
        state.info = action.payload;
        state.loading = false;
      },
      [reset.fulfilled]: (state) => {
        state.success = false;
        state.trade = {};
        state.loading = false;
      },
      [importCsv.fulfilled]: (state, action) => {
        state.loading = false;
        state.success = true;
        state.trade = action.payload;
        state.error = false;
      },
      [importCsv.pending]: (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      },
      [importCsv.rejected]: (state, action) => {
        state.error = true;
        state.info = action.payload;
        state.loading = false;
      },
      [bulkUpdateCsv.fulfilled]: (state, action) => {
        state.loading = false;
        state.success = true;
        state.trade = action.payload;
        state.error = false;
      },
      [bulkUpdateCsv.pending]: (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      },
      [bulkUpdateCsv.rejected]: (state, action) => {
        state.error = true;
        state.info = action.payload;
        state.loading = false;
      },
      [exportCsv.fulfilled]: (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.trade = {"result": "Trades Exported Successfully"};
      },
      [exportCsv.pending]: (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      },
      [exportCsv.rejected]: (state, action) => {
        state.error = true;
        state.info = action.payload;
        state.loading = false;
      },
    },
  });

  const tradeReducer = tradeSlice.reducer;
  export default tradeReducer;
